import { render, staticRenderFns } from "./deployfor.vue?vue&type=template&id=9b4f0d54&scoped=true&"
import script from "./deployfor.vue?vue&type=script&lang=js&"
export * from "./deployfor.vue?vue&type=script&lang=js&"
import style0 from "./deployfor.vue?vue&type=style&index=0&id=9b4f0d54&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4f0d54",
  null
  
)

export default component.exports